import { Checkbox, FormControlLabel } from "@mui/material";

type CheckBoxProps = {
  labelPlacement?: "bottom" | "end" | "start" | "top";
  label?: string;
  onChange: (e?: any) => void;
  value: any;
  className?: string;
  style?: any;
  id?: string;
  name?: string;
  disabled?: true | false;
};

export default function CheckBoxComponent(props: CheckBoxProps) {
  return (
    <FormControlLabel
      checked={props.value}
      onChange={(e) => props.onChange(e)}
      control={<Checkbox />}
      className={props.className}
      label={props.label}
      labelPlacement={props.labelPlacement}
      name={props.name}
      id={props.id}
      disabled={props.disabled}
    />
  );
}
